export interface IAutoSuggestProps {
  /** Query string value */
  query?: string
  /** Whether suggestions should show */
  showSuggestions?: boolean
  /** Whether it's loading */
  isLoading?: boolean
  /** Suggestions to display */
  suggestions?: any[]
  /** Function to render suggestion list */
  renderSuggestions?: (
    suggestions: any[]
  ) => React.ReactNode | React.ReactNode[]
  /** Function to render no results alternatives */
  renderNoResultsHaveAlternatives?: () => React.ReactNode
  /** Function to handle search input change */
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  /** Function to handle key events on search input */
  handleKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void
  /** Function to handle enter key or search submission */
  handleEnter?: (e?: React.KeyboardEvent<HTMLInputElement>) => void
  /** Function to handle input focus */
  handleFocus?: () => void
  /** Function to handle input blur */
  handleBlur?: () => void
  /** Placeholder text for search input */
  placeholderText?: string
  /** Whether user is AUS GA */
  isAusGa?: boolean
  /** Whether this is menu search */
  isMenuSearch?: boolean
  /** Whether this AutoSuggest is used in header context (affects styling) */
  isHeader?: boolean
}

/**
 * Check if path exists in this current route
 * @param str
 * @param expressions
 */
export const matchInArray = (str: string, expressions: string[]): boolean => {
  for (const item of expressions) {
    if (str?.match(item)) {
      return true
    }
  }
  return false
}
